import {Flex, Image, Text} from '@chakra-ui/react'
import CheckedIcon from '@assets/svgs/revise/checked.svg'
import FailIcon from '@assets/svgs/revise/failed.svg'
import {useSelector} from 'react-redux'

const MessageReply = ({data, isResult}: {data: any; isResult: any}) => {
  const {currentQuestion} = useSelector((state: any) => state.revise)
  function isString(value: any) {
    return value instanceof String || typeof value === 'string'
  }

  switch (currentQuestion.type) {
    case 'LV2_LISTEN_AND_FILL_THE_BLANK':
      return (
        <Flex
          alignItems={'center'}
          w={'90%'}
          ml={'auto'}
          mb={'16px'}
          justifyContent={'end'}>
          <Flex
            flexDirection={'column'}
            position={'relative'}
            border={'2px solid #73D13D'}
            borderColor={isResult ? '#73D13D' : '#FFA39E'}
            gap={'4px'}
            flexWrap={'wrap'}
            fontSize={'16px'}
            p={'16px'}
            bg={isResult ? '#F6FFED' : '#FFF2F1'}
            borderRadius={'32px'}
            ml={'auto'}>
            <Image
              src={isResult ? CheckedIcon : FailIcon}
              w={'20px'}
              h={'20px'}
              position={'absolute'}
              top={'-6px'}
              right={'5px'}
            />
            <Flex
              gap={'4px'}
              flexWrap={'wrap'}
              w={'fit-content'}
              alignItems={'center'}>
              {data.msg.map((item: any, index: any) => {
                return (
                  <Text
                    opacity={isResult ? 1 : 0.5}
                    key={index}
                    mx={item.type === 'option' ? '4px' : '0px'}
                    p={item.type === 'option' ? '6px 15px' : 'unset'}
                    borderRadius={item.type === 'option' ? '12px' : 'unset'}
                    border={
                      item.type === 'option' ? '1px solid #D9D9D9' : 'unset'
                    }
                    fontWeight={item.type === 'option' ? 600 : 500}
                    color={isResult ? '#237804' : 'unset'}
                    bg={item.type === 'option' ? 'white' : 'unset'}>
                    {item.text}
                  </Text>
                )
              })}
            </Flex>
            {!isResult && (
              <Text fontSize={'13px'} fontWeight={500}>
                Đáp án
              </Text>
            )}
            {!isResult && (
              <Text fontSize={'16px'} fontWeight={500}>
                {currentQuestion.data.question.full_answer}
              </Text>
            )}
          </Flex>
        </Flex>
      )
    case 'LV2_LISTEN_AND_CHOOSE_PHRASE':
      return (
        <Flex
          alignItems={'center'}
          w={'90%'}
          ml={'auto'}
          mb={'16px'}
          justifyContent={'end'}>
          <Flex
            flexDirection={'column'}
            position={'relative'}
            border={'2px solid #73D13D'}
            borderColor={isResult ? '#73D13D' : '#FFA39E'}
            gap={'4px'}
            flexWrap={'wrap'}
            fontSize={'16px'}
            p={'16px'}
            bg={isResult ? '#F6FFED' : '#FFF2F1'}
            borderRadius={'32px'}
            ml={'auto'}>
            <Image
              src={isResult ? CheckedIcon : FailIcon}
              w={'20px'}
              h={'20px'}
              position={'absolute'}
              top={'-6px'}
              right={'5px'}
            />
            <Flex
              gap={'4px'}
              flexWrap={'wrap'}
              w={'fit-content'}
              alignItems={'center'}>
              {data.msg.map((item: any, index: any) => {
                return (
                  <Text
                    key={index}
                    textDecoration={
                      item.type === 'option' && !isResult
                        ? 'line-through'
                        : 'unset'
                    }
                    opacity={isResult ? 1 : 0.5}
                    mx={item.type === 'option' ? '4px' : '0px'}
                    fontWeight={500}
                    color={isResult ? '#237804' : 'unset'}>
                    {item.text}
                  </Text>
                )
              })}
            </Flex>
            {!isResult && (
              <Text fontSize={'13px'} fontWeight={500}>
                Đáp án
              </Text>
            )}
            {!isResult && (
              <Text fontSize={'16px'} fontWeight={500}>
                {currentQuestion.data.question.full_answer}
              </Text>
            )}
          </Flex>
        </Flex>
      )
    case 'LV3_LISTEN_AND_ANSWER_BY_TYPING':
      return (
        <Flex
          alignItems={'center'}
          w={'90%'}
          ml={'auto'}
          mb={'16px'}
          justifyContent={'end'}>
          <Flex
            flexDirection={'column'}
            p={'16px'}
            bg={isResult ? '#F6FFED' : '#FFF2F1'}
            borderRadius={'32px'}
            border={'2px solid #73D13D'}
            borderColor={isResult ? '#73D13D' : '#FFA39E'}
            position={'relative'}>
            <Image
              src={isResult ? CheckedIcon : FailIcon}
              w={'20px'}
              h={'20px'}
              position={'absolute'}
              top={'-7px'}
              right={'5px'}
            />
            <Text
              opacity={isResult ? 1 : 0.5}
              textDecoration={isResult ? 'unset' : 'line-through'}
              fontSize={'16px'}
              color={isResult ? '#237804' : 'unset'}
              fontWeight={500}>
              {isString(data.msg) && data.msg}
            </Text>
            {!isResult && (
              <Text fontSize={'13px'} fontWeight={500}>
                Đáp án
              </Text>
            )}
            {!isResult && (
              <Text fontSize={'16px'} fontWeight={500}>
                {currentQuestion.data.question.full_answer}
              </Text>
            )}
          </Flex>
        </Flex>
      )
    case 'LV3_LISTEN_AND_ANSWER_BY_SPEAKING':
      return (
        <Flex
          alignItems={'center'}
          w={'90%'}
          ml={'auto'}
          mb={'16px'}
          justifyContent={'end'}>
          <Flex
            flexDirection={'column'}
            p={'16px'}
            bg={isResult ? '#F6FFED' : '#FFF2F1'}
            borderRadius={'32px'}
            border={'2px solid #73D13D'}
            borderColor={isResult ? '#73D13D' : '#FFA39E'}
            position={'relative'}>
            <Image
              src={isResult ? CheckedIcon : FailIcon}
              w={'20px'}
              h={'20px'}
              position={'absolute'}
              top={'-7px'}
              right={'5px'}
            />
            <Text
              opacity={isResult ? 1 : 0.5}
              textDecoration={isResult ? 'unset' : 'line-through'}
              fontSize={'16px'}
              color={isResult ? '#237804' : 'unset'}
              fontWeight={500}>
              {isString(data.msg) && data.msg}
            </Text>
            {!isResult && (
              <Text fontSize={'13px'} fontWeight={500}>
                Đáp án
              </Text>
            )}
            {!isResult && (
              <Text fontSize={'16px'} fontWeight={500}>
                {currentQuestion.data.question?.full_answer}
              </Text>
            )}
          </Flex>
        </Flex>
      )
    default:
      return <Flex>default</Flex>
  }
}

export default MessageReply
